<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 
<vue-snotify/>

<div v-if="check_mobile()">


<div style="margin-bottom:0em;" class="columns colBorderThin is-mobile is-gapless is-vcentered" v-for ="(stud, ind) in data_student" :key="randomKey(ind)" >
<div class="column is-2">          
<figure class="image is-32x32">
<img class="is-rounded" :src="return_pic(stud.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="....">
</figure>       
</div>
<div class="column is-7">         
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold" style="">{{stud.student_lNAME}}</div>
        <div class="column is-12 is-size-7" style=""> {{stud.student_fNAME}}</div>
    </div>
</div>
<div class="column is-3 has-text-centered" style="border-left:1px solid gray;"> 
    {{check_mark_remark(stud.cs_MARK,stud.cs_REMARK)}}
</div>


</div><!-- END COLUMN STUDENTS -->

</div>
<!-- END MOBILE !!!! -->

<div v-if="!check_mobile()">



<div class="table-container" style="margin-bottom:10em;">
  <table class="table is-narrow is-striped">
  <thead>
    <tr>
      <th v-if="isReadOnly"> <div style="width: 200px;"> 
          <div class="columns is-gapless"><div class="column is-12">  
            <button @click="toggle_readOnly()" class="button is-frameless is-fullwidth has-text-weight-bold has-background-primary has-text-white" style="padding: 0;border: none;background: none;"><span class="icon is-small has-text-left is-size-5"><i class="fas fa-edit"></i>&nbsp;&nbsp;&nbsp;&nbsp;MOD NOTES</span>     </button>
          </div></div>
     </div></th>  
    <th v-else><div style="width: 200px;">
        <div class="columns is-gapless">
            <div class="column is-4 has-text-centered has-background-danger">
                <button @click="toggle_readOnly()" class="button is-fullwidth has-text-weight-bold has-background-danger has-text-white" style="">
                    <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
                </button>
            </div>
            <div class="column is-8 has-text-centered has-background-success">
                <button @click="save_note_start()" class="button is-fullwidth has-text-weight-bold has-background-success has-text-white" style="">
                    <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
                </button>
            </div>
        </div>
    </div></th>


      <th v-for ="(info, index) in data_ponderation" :key="randomKey(index)">
        <div class="columns is-multiline is-mobile is-gapless is-vcentered has-text-centered" >
            <div class="column is-12 is-size-6 has-text-weight-bold">{{info.ponderation_Desc}}</div>
            <div class="column is-12 has-text-weight-bold is-size-7">  {{info.ponderation_Max}} : {{info.ponderation_Percent}}%</div>
        </div>
      </th>
      <th><div style="width: 200px;"> TOTAL </div></th>
    </tr>
  </thead>

  <tfoot>
    <tr>
      <th> - </th>

      <th v-for ="(info, index) in data_ponderation_avg" :key="randomKey(index)">
        <div class="columns is-multiline is-mobile is-gapless is-vcentered has-text-centered" >
            <div class="column is-12 is-size-6 has-text-weight-bold">{{return_average(info.ponderation_AVG)}}</div>

  
    <div class="column is-12 has-text-centered is-size-7 mt-3">FIN&nbsp;&nbsp;
        <input @change="change_pond_done(index)" :disabled="isReadOnly" v-model="info.ponderation_DONE" type="checkbox" :id="info.ponderation_ID*4" class="checkbox is-fullwidth" />  
        <label :for="info.ponderation_ID*4" class="switch is-fullwidth"></label>
    </div>

    <div v-if="check_pond_public_rights()" class="column is-12 has-text-centered is-size-7">PUB&nbsp;
        <input :disabled="isReadOnly" v-model="info.ponderation_PUBLIC" type="checkbox" :id="info.ponderation_ID" class="checkbox is-fullwidth" />  
        <label :for="info.ponderation_ID" class="switch"></label>
    </div>

        </div>
      </th>


<th>

        <div class="columns is-gapless mt-3">
            <div class="column is-6 has-text-centered">{{grp_average}}</div>

            <div v-if="check_pond_public_rights()" class="column is-6 is-size-7 has-text-centered">PUB&nbsp;
                <input :disabled="isReadOnly" v-model="grp_public" type="checkbox" :id="group_id" class="checkbox is-fullwidth" />  
                <label :for="group_id" class="switch"></label>
            </div>

        </div>


</th>



    </tr>
  </tfoot>

  <tbody>
        <tr v-for ="(dataTbl, indexTbl) in data_table" :key="randomKey(indexTbl)">
            <td>
<div class="columns is-gapless is-multiline has-text-weight-bold">
<div class="column is-12 is-size-6">{{dataTbl.nom}}</div>    
<div class="column is-12 is-size-7 has-text-grey-light">{{dataTbl.prenom}}</div>  
</div>


            </td>
            <td v-for ="(note, index) in dataTbl.notes" :key="randomKey(index)">
            <CompNotePond
                :key="indexTbl+index"
                :note="note.note"
                :enabled="isReadOnly"
                :pond_id="note.pond_id"
                :cs_id="note.cs_id"
                @emit_note_update="emit_note_update">               
            </CompNotePond> 
            </td>

<td>
        <CompNoteFinal
        :enabled="isReadOnly"
        @emit_remark_update="emit_remark_update" :cs_id="data_table[indexTbl].cs_id" 
        :note="data_table[indexTbl].note_final" :remark="data_table[indexTbl].remark">
        </CompNoteFinal>

</td>




        </tr>  
  </tbody>          
  </table>
</div>



<!-- <div class="columns is-multiline is-gapless is-mobile" style="margin-bottom:0em;">



<div v-if="isReadOnly" class="column is-2 colBorder has-text-centered has-background-primary has-text-white">
    <button @click="toggle_readOnly()" class="button is-frameless is-fullwidth has-text-weight-bold has-background-primary has-text-white" style="padding: 0;border: none;background: none;">
        <span class="icon is-small has-text-left is-size-5"><i class="fas fa-edit"></i>&nbsp;&nbsp;&nbsp;&nbsp;MOD NOTES</span>     
    </button>
</div>
<div v-else class="column is-2 colBorder has-text-centered">
    <div class="columns is-gapless">
        <div class="column is-4 has-text-centered has-background-danger">
            <button @click="toggle_readOnly()" class="button is-fullwidth has-text-weight-bold has-background-danger has-text-white" style="">
                <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
            </button>
        </div>
        <div class="column is-8 has-text-centered has-background-success">
            <button @click="save_note_start()" class="button is-fullwidth has-text-weight-bold has-background-success has-text-white" style="">
                <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
            </button>
        </div>
    </div>
</div>


<div class="column is-1 colBorder is-size-7 has-background-light"  v-for ="(info, index) in data_ponderation" :key="randomKey(index)">
   
<div class="columns is-multiline is-mobile is-gapless is-vcentered has-text-centered" >
<div class="column is-12 is-size-6 has-text-weight-bold">{{info.ponderation_Desc}}</div>
<div class="column is-12 has-text-weight-bold">  {{info.ponderation_Max}} : {{info.ponderation_Percent}}%</div>
</div>

</div>
<div class="column is-2 is-size-6 colBorder has-text-centered has-background-grey-lighter"></div>
</div>



<div class="columns is-multiline is-gapless is-mobile is-flex" style="">
<div class="column is-2 has-text-weight-bold">
<div class="columns is-gapless is-multiline colBorder" style="margin-bottom:0em;" v-for ="(stud, ind) in data_student" :key="randomKey(ind)"> 

<div class="column is-11 is-size-6">&nbsp;{{stud.student_lNAME}}<span class="is-size-7 has-text-grey-light	">, {{stud.student_fNAME}} </span></div>

<div class="column is-1"> <input min="0" class="input" type="text" placeholder="" value=""> </div>




        </div>
</div>
 


<div class="column is-1"  v-for ="(pond, indexPond) in data_pond_notes" :key="randomKey(indexPond)">
   <div class="columns is-gapless is-multiline colBorder" style="margin-bottom:0em;" v-for ="(n,indexKey) in pond" :key="randomKey(indexKey)">
<div class="column is-12 is-size-6">
             <CompNotePond
                :key="indexKey"
                :pond_index="indexPond"
                :key_index="indexKey"
                :enabled="isReadOnly"
                @emit_note_update="emit_note_update"
               :note="n.note" :n_id="n.n_id" :pond_id="n.pond_id" :cs_id="n.cs_id">               
            </CompNotePond> 
</div>   
    </div>
</div>

<div class="column is-2">
    <div class="colBorder" v-for ="(stud, ind) in data_student" :key="randomKey(ind)">
        <CompNoteFinal
        :enabled="isReadOnly"
        @emit_remark_update="emit_remark_update" :stud_index="ind" :note="stud.cs_MARK" :remark="stud.cs_REMARK" :id="stud.cs_MARK"></CompNoteFinal>
    </div>
</div>

</div>




<div class="columns is-multiline is-gapless is-mobile" style="margin-top:-1.6em;margin-bottom:2em;">
<div class="column is-2 colBorder has-text-centered"></div>
<div class="column is-1 colBorder has-background-light"  v-for ="(info, index) in data_ponderation_avg" :key="randomKey(index)">
   
<div class="columns has-background-grey-lighter is-multiline is-mobile is-gapless is-vcentered has-text-centered" >
<div class="column is-12 is-size-4 has-background-grey-lighter has-text-weight-bold" style="margin-bottom:.5em;">

{{return_average(info.ponderation_AVG)}}

</div>


    <div class="column is-5 is-size-7 has-background-grey-lighter has-text-weight-bold">&nbsp;FIN.</div>
    <div class="column is-7 has-text-centered has-background-grey-lighter">
        <input @change="change_pond_done(index)" :disabled="isReadOnly" v-model="info.ponderation_DONE" type="checkbox" :id="info.ponderation_ID*4" class="checkbox is-fullwidth" />  
        <label :for="info.ponderation_ID*4" class="switch"></label>
    </div>




    <div v-if="check_pond_public_rights()" class="column is-5 is-size-7 has-background-grey-lighter has-text-weight-bold">&nbsp;PUB.</div>
    <div v-if="check_pond_public_rights()" class="column is-7 has-text-centered has-background-grey-lighter">
        <input :disabled="isReadOnly" v-model="info.ponderation_PUBLIC" type="checkbox" :id="info.ponderation_ID" class="checkbox is-fullwidth" />  
        <label :for="info.ponderation_ID" class="switch"></label>
    </div>
    <div v-else class="column is-6 has-text-centered has-background-grey-lighter">&nbsp;</div>

</div>

</div>
    <div class="column is-2 colBorder has-text-centered is-size-3 has-text-weight-bold has-background-grey-lighter">
        <div class="columns is-gapless">
            <div class="column is-6">{{grp_average}}</div>

            <div v-if="check_pond_public_rights()" class="column is-6 has-text-centered">
                <input :disabled="isReadOnly" v-model="grp_public" type="checkbox" :id="group_id" class="checkbox is-fullwidth" />  
                <label :for="group_id" class="switch"></label>
            </div>

        </div>
        
    </div>
</div> -->

</div>


</div>
</template>



<script>
import axios from 'axios';
import CompNotePond  from '@/components/Comp_notePond';
import CompNoteFinal  from '@/components/comp_noteFinal';

export default {
        //props: [ 'data_student', 'data_ponderation', 'notes_data'],
        props: [ 'group_id' ],
        components: {  CompNotePond, CompNoteFinal },

        data() {
            return {
                 students:'',
                 isLoading:false,

                 data_group:[],

    data_ponderation:[],
    data_ponderation_avg:[],

                 data_student:[],
                 notes_data:[],


grp_average: '',
grp_public: false,

data_pond_notes:[],
data_pond_notes_temp:[],
notes_save_string:[],
isReadOnly:true,

show_notification_registrar:false,

data_table : [],

            }
        },

created() {
this.isLoading = true;
var self = this;
var sql;


// GET GROUP INF0
sql=`SELECT group_AVG, group_PUBLIC FROM MyMEQ_GROUP
WHERE  (group_ID = ` + this.group_id + `)`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 

console.log( 'GROUP NOTES: ' + res.data)
this.grp_average = res.data[0].group_AVG
this.grp_public = +res.data[0].group_PUBLIC
 

sql=`SELECT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME,MyMEQ_STUDENT.student_fNAME,student_GRPCODE,student_PhotoPath, MyMEQ_PROF_NOTES.note_ID , MyMEQ_PROF_NOTES.note_NOTE, MyMEQ_PROF_PONDERATION.*  ,MyMEQ_COURSESTUDENT.cs_ID,cs_MARK,cs_REMARK, MyMEQ_GROUP.group_AVG, MyMEQ_GROUP.group_blnComplete, MyMEQ_GROUP.group_PUBLIC FROM  MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID  LEFT OUTER JOIN MyMEQ_PROF_NOTES ON MyMEQ_COURSESTUDENT.cs_ID = MyMEQ_PROF_NOTES.cs_ID LEFT OUTER JOIN MyMEQ_PROF_PONDERATION ON MyMEQ_PROF_NOTES.ponderation_ID = MyMEQ_PROF_PONDERATION.ponderation_ID LEFT OUTER JOIN  MyMEQ_GROUP ON MyMEQ_PROF_PONDERATION.group_ID = MyMEQ_GROUP.group_ID 
WHERE  (MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + `) ORDER BY student_lNAME`
console.log(sql)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
    this.data_group = res.data


//1. GET PONDERATION
var sql = 'SELECT * FROM MyMEQ_PROF_PONDERATION WHERE group_ID = ' + this.group_id + " ORDER BY ponderation_Order"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
    this.data_ponderation = res.data
    this.data_ponderation_avg = res.data //this.data_ponderation

/* var sql = 'SELECT * FROM MyMEQ_PROF_PONDERATION WHERE group_ID = ' + this.group_id + " ORDER BY ponderation_ID" 
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => { 
    this.data_ponderation_avg = res.data */
   


sql = "SELECT MyMEQ_STUDENT.*, cs_ID, cs_MARK, cs_REMARK FROM MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID "
sql += " WHERE group_ID = " + this.group_id + " ORDER BY student_lNAME"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
    this.data_student = res.data


this.sort_notes_start()
this.isLoading = false;
}) // END STUDS
}) // END 
}) // END POND
}) // END MAIN SQL

},


methods: {

check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},

check_pond_public_rights() {
// CHECK IF HAS RIGHTS TO GO PUBLIC
    if (sessionStorage.getItem('user_level') == 'ADMIN') {return true} else {return false}
},
change_pond_done(index) {
// CHECK IF DONE CHANGED TRUE
    if (+this.data_ponderation_avg[index].ponderation_DONE == true)
    {this.show_notification_registrar = true}
    else {this.show_notification_registrar = false}
},

check_mark_remark(mark,remark) {
    if (remark == 'EQ') {return remark}
    else if (mark == "0") {return remark}
    else {return this.return_average(mark) + '% ' + remark}
},

return_average:function(avg) {

    try { return Math.round(avg)}
    catch { return '-'}

},

emit_remark_update:function(cs_id, remark) {


//UPDATE DISPLAY DATA
var idxPond
for( idxPond = 0; idxPond < this.data_table.length; idxPond++ ){
        if (this.data_table[idxPond].cs_id == cs_id )
        {this.data_table[+idxPond].remark = remark ; break }
} // END FOR

//UPDATE MAIN DATA
var idxStud
for( idxStud = 0; idxStud < this.data_student.length; idxStud++ ){
        if (this.data_student[idxPond].cs_ID == cs_id )
        {this.data_student[idxStud].cs_REMARK = remark ; break }
} // END FOR

},


toggle_readOnly:function() {


   // this.isLoading = true;
    if (+this.isReadOnly == true)
    {       this.isReadOnly = false
            //this.sort_notes_start()
           }
    else { this.isReadOnly = true
           // this.sort_notes_start() 
           }
},


// ************************************************ SAVE
save_note_start:function() {
    this.isLoading=true;
    
    this.doSynchronousLoop(this.data_pond_notes,this.save_string_append, this.save_note_end)
},
save_string_append:function(item, i, callback) {
var self = this;
this.notes_save_string = ''
this.data_pond_notes[i].forEach(function(dataNote){

var note = 'NULL'
if (parseFloat(dataNote.note)>-1) {note = dataNote.note}

    if (dataNote.n_id == "0" )
    { 
        if (dataNote.note != '') {        
            self.notes_save_string +=  "INSERT INTO MyMEQ_PROF_NOTES (ponderation_ID, cs_ID,note_NOTE) VALUES ("
            self.notes_save_string += dataNote.pond_id + "," + dataNote.cs_id + "," + note + ");"
        }
    }
    else 
    { self.notes_save_string += "UPDATE MyMEQ_PROF_NOTES SET note_NOTE = " + note + " WHERE note_ID = " + dataNote.n_id + ";"  }

});
     
axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(this.notes_save_string)}, 
})
.then(res => {
    callback();
})

// SAVE EACH POND HERE !!!! 
    // axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(this.notes_save_string))
    // .then(res => { 

    // this.$snotify.success( this.data_ponderation[i].ponderation_Desc + ' enregistrée !!', {
    //     timeout: 1000,showProgressBar: true,closeOnClick: false,pauseOnHover: false
    // });

    //     callback();
    // })
    
},
save_note_end:function() {

//   axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(this.notes_save_string))
//   .then(res => { 


// SAVE PONDERATION AVERAGES
var query = '';
this.data_ponderation_avg.forEach(function(data){ 
    
var val = 'NULL'
if (parseFloat(data.ponderation_AVG)>-1) {val = data.ponderation_AVG}

  query += "UPDATE MyMEQ_PROF_PONDERATION SET ponderation_AVG = " + val + ", ponderation_PUBLIC = " + +data.ponderation_PUBLIC + ", ponderation_DONE = " + +data.ponderation_DONE
  query += " WHERE ponderation_ID = " + data.ponderation_ID + ";"
})   
// SAVE STUDENT AVERAGES
this.data_student.forEach(function(data){    
    
var val = 'NULL'
if (parseFloat(data.cs_MARK)>-1) {val = data.cs_MARK}

  query += "UPDATE MyMEQ_COURSESTUDENT SET cs_MARK = " + val + ", cs_REMARK = '" + data.cs_REMARK
  query += "' WHERE cs_ID = " + data.cs_ID + ";"
})

// SAVE GROUP AVERAGE
var val = 'NULL'
if (parseFloat(this.grp_average)>-1) {val = this.grp_average}
query += "UPDATE MyMEQ_GROUP SET group_AVG = " + val + ", group_PUBLIC = " + +this.grp_public + ", group_blnComplete = " + +this.grp_public
query += " WHERE group_ID = " + this.group_id + ";"


console.log(query)

axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(query)}, 
})
.then(res => {
    this.isLoading=false; 
})

  
},
// ************************************************ SAVE
 
// emit_note_update:function(note, pond_index, key_index) {
emit_note_update:function(note, pond_id, cs_id) {


var pond_index, key_index, idxTable
// FIND THE INDEX(s)
for( var idxPond = 0; idxPond < this.data_pond_notes.length; idxPond++ ){
    for( var idxNote = 0; idxNote < this.data_pond_notes[idxPond].length; idxNote++ ){
        if (this.data_pond_notes[idxPond][idxNote].pond_id == pond_id && this.data_pond_notes[idxPond][idxNote].cs_id == cs_id )
        {pond_index = idxPond ; key_index = idxNote ; break }
} }// END FORS

//UPDATE DISPLAY DATA
for( idxPond = 0; idxPond < this.data_table.length; idxPond++ ){
    for( idxNote = 0; idxNote < this.data_table[idxPond].notes.length; idxNote++ ){
        if (this.data_table[idxPond].notes[idxNote].pond_id == pond_id && this.data_table[idxPond].notes[idxNote].cs_id == cs_id )
        {idxTable = idxPond ;  this.data_table[+idxPond].notes[+idxNote].note = +note ; break }
} }// END FORS

 

setTimeout(() => {   

// !IMPORTANT
    this.data_pond_notes[+pond_index][+key_index].note = +note


// DO POND !! AVERAGE
var sum = 0;
for( var i = 0; i < this.data_pond_notes[+pond_index].length; i++ ){
   //alert(this.data_pond_notes[+pond_index][i].note) 
    sum += +this.data_pond_notes[+pond_index][i].note // parseInt( this.data_pond_notes[+pond_index][i].note, 10 ); //don't forget to add the base
}
var avg = sum/this.data_pond_notes[+pond_index].length;
this.data_ponderation_avg[+pond_index].ponderation_AVG = Math.round(avg)

// DO STUDENT !! AVERAGE
var pMax = 0;
var pPerc = 0; 
var pTotal = 0;
for( i = 0; i < this.data_pond_notes.length; i++ ){
    pMax = ((+this.data_pond_notes[i][key_index].note / +this.data_ponderation_avg[i].ponderation_Max) * 100) 
    pPerc = (+this.data_ponderation_avg[i].ponderation_Percent / 100)
    pTotal += (pMax * pPerc)
}
this.data_student[key_index].cs_MARK = Math.round(pTotal)
this.data_table[+idxTable].note_final = Math.round(pTotal) // DISPLAY

// DO COURSE AVERAGE  
sum = 0;
for( i = 0; i < this.data_student.length; i++ ){
   //alert(this.data_pond_notes[+pond_index][i].note) 
    sum += +this.data_student[i].cs_MARK // parseInt( this.data_pond_notes[+pond_index][i].note, 10 ); //don't forget to add the base
}
avg = sum/this.data_student.length;
this.grp_average = Math.round(avg)

}, 200);
// END TIMEOUT !


},

// ************************************************ NOTES
sort_notes_start:function() {
    this.data_pond_notes = []
    this.data_pond_notes_temp = []
    this.doSynchronousLoop(this.data_ponderation,this.return_ponderation_marks, this.sort_notes_end)
},


return_ponderation_marks:function(item, i, callback) {

var pond_id_in = item.ponderation_ID

var tempArr=[]
var returnArr=[]

var data_copy = this.data_group

// GET NOTES FOR THIS POND -- IF THEY HAVE THEM !!!!
this.data_group.forEach(function(data){ 
// for (i = 0; i < tempArr.length; i++) {
if (data.ponderation_ID == pond_id_in) {tempArr.push({ note : data.note_NOTE, n_id : data.note_ID, pond_id : pond_id_in, cs_id : data.cs_ID, stud_id : data.student_ID});}
}) // END GRP LOOP

var self=this;
// CHECK FOR BLANCS
this.data_student.forEach(function(data){ 
var indx = tempArr.findIndex(x => x.stud_id == data.student_ID)
if (indx > -1) 
    {returnArr.push({ note : tempArr[indx].note, n_id : tempArr[indx].n_id, pond_id : tempArr[indx].pond_id, cs_id : tempArr[indx].cs_id, stud_id : tempArr[indx].stud_id});}
else {

// NOT NOT FOUND! 
    var pIndex = data_copy.findIndex(x => x.student_ID == data.student_ID )
    //alert(data_copy[pIndex].cs_ID)
    {returnArr.push({ note : '', n_id : 0, pond_id : pond_id_in, cs_id : data_copy[pIndex].cs_ID});}  

} 

}) // END STUD LOOP

this.data_pond_notes_temp[i] = returnArr;
callback();
},

sort_notes_end:function() { 
    this.data_pond_notes = this.data_pond_notes_temp


// SORT OUT DATA FOR TABLE 
this.data_table = []
var self=this;
this.data_student.forEach(function(dataStud){
    // console.log()
    var tempNotes = []
    // var csID
    self.data_pond_notes.forEach(function(dataPond){
        dataPond.forEach(function(dataNote){
            if (dataNote.cs_id == dataStud.cs_ID)
            // csID = dataNote.cs_id
            {tempNotes.push({
                note : dataNote.note,
                cs_id : dataNote.cs_id , 
                pond_id : dataNote.pond_id , 
            })}
        }); // END FOR-EACH NOTE 
    }); // END FOR-EACH POND 


self.data_table.push({ 
    nom : dataStud.student_lNAME , 
    prenom : dataStud.student_fNAME ,
    note_final : dataStud.cs_MARK , 
    remark : dataStud.cs_REMARK , 
    notes : tempNotes,
    cs_id : dataStud.cs_ID

})


}); // END FOR-EACH STUD 




    this.isLoading = false;    
},
// ************************************************ NOTES








// GET NEW POND AVERAGE
/*     var query = "SELECT CAST(AVG(note_NOTE) AS FLOAT) AS pondAvg FROM MyMEQ_PROF_NOTES WHERE (ponderation_ID = " + pondID +")"
    console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        var indX = this.data_ponderation_avg.findIndex(x => x.ponderation_ID == pondID)
        this.data_ponderation_avg[indX].ponderation_AVG = res.data[0].pondAvg
    }) */




// GENERATE A NEW ID! 
    randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},

return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},


doSynchronousLoop:function(data, processData, done) {
    if (data.length > 0) {
        var loop = function(data, i, processData, done) {
            processData(data[i], i, function() {
                if (++i < data.length) {  setTimeout(function(){ loop(data, i, processData, done);  }, 0);
                } else {    done();    }  });  };
        loop(data, 0, processData, done); } else { done(); }
},

}, // END METHODS



} // END EXPORT
</script>




<style scoped>

input{
    border-width:0px;
    border:none;
    cursor: default ;
}

select {
  text-align: center;
  text-align-last: center;
  font-weight: 900;
  /* webkit*/
}
option {
  text-align: left;
  /* reset to left*/
}

</style>